import "babel-polyfill"
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/zh-CN'
import App from './App'
import router from './router'
import store from './store'
import '@/icons' // icon


Vue.use(ElementUI, { locale })
Vue.config.productionTip = false

new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})

function attacheJquery(){

  $('img').unbind("contextmenu").bind("contextmenu",function(e){return false})
  $('img').unbind("dragstart").bind("dragstart", function(e) {return false})

  $('.el-button').unbind("click").bind("click",function(e){
    let that=$(e.target);
    that.attr("disabled", true);
    that.attr("readonly", true);
    setTimeout(function(){
      that.attr("disabled", false);
      that.attr("readonly", false);
    },2000)
  })

  $('.el-loading-text').html('')

  setTimeout(attacheJquery,2000)
}
$(function(){
  setTimeout(attacheJquery,2000)
});


// WEBPACK FOOTER //
// ./src/main.js